import { type FC } from 'react'
import { type BackdropProps, Drawer } from '@mui/material'

import SheetBody, { type SheetBodyProps } from './_internal/SheetBody'
import SheetHeader, { type SheetHeaderProps } from './_internal/SheetHeader'
import * as styles from './styles'

type BottomSheetProps = {
  ariaLabelledBy: string
  isOpen: boolean
} & SheetHeaderProps &
  SheetBodyProps

const BottomSheet: FC<BottomSheetProps> = ({ children, title, ariaLabelledBy, isOpen = false, onClose }) => (
  <Drawer
    slotProps={{
      backdrop: {
        'data-test': 'sheet-backdrop',
      } as Partial<BackdropProps>, // NOTE: This type assertion is legitimate https://github.com/mui-org/material-ui/issues/20160
      paper: {
        elevation: 0,
        style: styles.paper,
        role: 'dialog',
        'aria-labelledby': ariaLabelledBy,
      },
    }}
    anchor="bottom"
    open={isOpen}
    onClose={onClose}
    role={undefined}
  >
    <div css={styles.wrapper}>
      <SheetHeader onClose={onClose} />
      <SheetBody title={title}>{children}</SheetBody>
    </div>
  </Drawer>
)

export default BottomSheet
